import { FC, useRef, useState, useEffect } from "react";
import styles from "../../../Swap.module.scss";
import cn from "classnames";

interface Props {
    swapAmount: string;
    setSwapAmount: (value: string) => void;
    symbol: string;
    disabled: boolean;
}

const BuyBox: FC<Props> = ({ swapAmount, symbol, setSwapAmount, disabled = false }) => {
    const [hasBeenFocused, setHasBeenFocused] = useState(false);
    const [localValue, setLocalValue] = useState(swapAmount);
    const inputRef = useRef<HTMLInputElement>(null);

    // Update local value when swapAmount changes from outside
    useEffect(() => {
        setLocalValue(swapAmount);
    }, [swapAmount]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setLocalValue(newValue);
        // Always update the parent component with the new value
        setSwapAmount(newValue);
    };

    const handleFocus = () => {
        if (!hasBeenFocused && inputRef.current) {
            inputRef.current.select();
            setHasBeenFocused(true);
        }
    };

    return (
        <div className={styles.inputHolder}>
            <input
                ref={inputRef}
                disabled={disabled}
                value={localValue}
                onChange={handleChange}
                onFocus={handleFocus}
                placeholder={"0.00 " + symbol}
                className={cn(styles.input, "outline-none font-[400]")}
                type="text"
                inputMode="decimal"
                name="sellAmount"
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
                data-form-type="other"
            />
            <div className={styles.balance}></div>
        </div>
    );
};

export default BuyBox;
